const notificationNameSpace = 'notifications';

export default notificationNameSpace;
